export default __webpack_public_path__ + "1f3c1d74a45d8c6c6d4e7aed53ba5fa6.png";